import { createPageComponent } from "../utils/createPageComponent";
import { BaseErrorPage } from "../components/BaseErrorPage";

import { GeneralErrorPageButtons } from "./Error5xxButtons";

const Page = () => (
  <BaseErrorPage
    titleTransKey="generalError.title"
    infoTransKey="generalError.info"
    buttons={<GeneralErrorPageButtons />}
  />
);

export const GeneralErrorPage = createPageComponent(Page);
